enum ScheduleViewEnum {
    grid = 'grid',
    list = 'list',
}

const scheduleViewKey = 'schedule:view';

export { ScheduleViewEnum, scheduleViewKey };
